export const isValidDOB = (dob, minAge = 16) => {
    if (!dob) return false;

    const today = new Date();
    const minAllowedDate = new Date(
        today.getFullYear() - minAge,
        today.getMonth(),
        today.getDate()
    );

    return new Date(dob) < minAllowedDate;
};

export const isValidUrl = (value) => {
    const websiteRegex = /^(https?:\/\/)/i;
    return websiteRegex.test(value);
};
